import React, { useState, useEffect } from 'react';
import '../assets/styles/CadastroProdutor.css';
// import { supabase } from '../utils/supabase';
import { useNavigate } from 'react-router-dom';

export default function Perfil() {
  const [userId, setUserId] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [perfil, setPerfil] = useState('');
  const [dataCadastro, setDataCadastro] = useState('');
  const [ativo, setAtivo] = useState('');
  const [senhaHash, setSenhaHash] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Defina a URL base da API
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    async function fetchUserAndProfile() {
      setLoading(true);
      // 1. Buscar usuário logado (mock: localStorage, ou ajuste conforme seu auth)
      // Tenta buscar o usuário logado em várias chaves comuns do localStorage
      const possibleKeys = ['user', 'usuario', 'currentUser', 'auth', 'loggedUser'];
      let userAuth = null;
      let foundKey = '';
      for (const key of possibleKeys) {
        try {
          const userStr = localStorage.getItem(key);
          if (userStr) {
            userAuth = JSON.parse(userStr);
            foundKey = key;
            break;
          }
        } catch (e) {}
      }
      console.log('userAuth do localStorage:', userAuth, 'chave encontrada:', foundKey);
      // Não preenche mais os campos do perfil a partir do localStorage. Apenas pega o id.
      const idUsuario = userAuth && (userAuth.id || userAuth.id_auth || userAuth.user_id);
      if (!idUsuario) {
        setMessage(
          'Usuário não autenticado. Nenhum id encontrado.\nChave testada: ' + foundKey + '\nuserAuth encontrado: ' +
          JSON.stringify(userAuth, null, 2) +
          '\nDica: verifique no localStorage se existe alguma chave com o id do usuário logado.'
        );
        setLoading(false);
        return;
      }

      // 2. Buscar dados do perfil na API
      try {
        const url = `${API_BASE_URL}/usuarios/${idUsuario}`;
        console.log('Buscando perfil do usuário na URL:', url);
        const res = await fetch(url);
        if (!res.ok) throw new Error('Erro ao buscar perfil');
        const apiResponse = await res.json();
        console.log('Perfil retornado da API:', apiResponse);
        const usuario = apiResponse && Array.isArray(apiResponse.usuarios) && apiResponse.usuarios.length > 0 ? apiResponse.usuarios[0] : null;
        if (!usuario || !usuario.nome || !usuario.email) {
          setMessage('Perfil não encontrado ou resposta da API incompleta: ' + JSON.stringify(apiResponse));
          setUserId('');
          setName('');
          setEmail('');
          setPerfil('');
          setDataCadastro('');
          setAtivo('');
        } else {
          setUserId(usuario.id || '');
          setName(usuario.nome || '');
          setEmail(usuario.email || '');
          setPerfil(usuario.perfil || '');
          setDataCadastro(usuario.data_cadastro || '');
          setAtivo(usuario.ativo || '');
          setSenhaHash(usuario.senha_hash || '');
        }
      } catch (err) {
        setMessage('Erro ao buscar perfil: ' + err.message);
        setName('');
        setEmail('');
        setPerfil('');
        setDataCadastro('');
        setAtivo('');
      }
      setLoading(false);
    }
    fetchUserAndProfile();
    // eslint-disable-next-line
  }, [API_BASE_URL]);

  const handleSave = async () => {
    setMessage('');
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/usuarios/update`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: userId,
          nome: name,
          email: email,
          senha_hash: senhaHash, // Mantém a senha original
          perfil: perfil,
          data_cadastro: dataCadastro,
          ativo: ativo
        })
      });
      if (!res.ok) throw new Error('Erro ao atualizar perfil');
      setMessage('Perfil atualizado com sucesso.');
    } catch (err) {
      setMessage('Erro ao salvar perfil: ' + err.message);
    }
    setLoading(false);
  };

  return (
    <div className="cadastro-produtor-container" style={{ maxWidth: 500, margin: '32px auto', background: '#fff', borderRadius: 10, boxShadow: '0 2px 8px #0001', padding: 24 }}>
      <h2 style={{ textAlign: 'center', fontWeight: 700, color: '#3d3d3d', marginBottom: 18 }}>Perfil do Usuário</h2>
      {/* Debug: mostrar userAuth se não autenticado */}
      {message && message.startsWith('Usuário não autenticado') && (
        <pre style={{ color: 'red', background: '#fff0f0', padding: 10, borderRadius: 6, fontSize: 13, marginBottom: 10 }}>{message}</pre>
      )}
      {loading ? (
        <div style={{ textAlign: 'center', color: '#888', fontSize: 18, padding: '40px 0' }}>Carregando...</div>
      ) : (
      <form className="cadastro-form" onSubmit={e => { e.preventDefault(); handleSave(); }} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <label htmlFor="userId" style={{ fontWeight: 500 }}>ID</label>
          <input id="userId" type="text" value={userId} disabled style={{ background: '#f5f5f5' }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <label htmlFor="name" style={{ fontWeight: 500 }}>Nome</label>
          <input id="name" type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Nome" autoComplete="name" />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <label htmlFor="email" style={{ fontWeight: 500 }}>Email</label>
          <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" autoComplete="email" />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <label htmlFor="perfil" style={{ fontWeight: 500 }}>Perfil</label>
          <input id="perfil" type="text" value={perfil} disabled style={{ background: '#f5f5f5' }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <label htmlFor="dataCadastro" style={{ fontWeight: 500 }}>Data de Cadastro</label>
          <input id="dataCadastro" type="text" value={dataCadastro ? (typeof dataCadastro === 'string' && !isNaN(Date.parse(dataCadastro)) ? new Date(dataCadastro).toLocaleString() : dataCadastro) : ''} disabled style={{ background: '#f5f5f5' }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <label htmlFor="ativo" style={{ fontWeight: 500 }}>Ativo</label>
          <input id="ativo" type="text" value={ativo && (ativo.toLowerCase() === 's' ? 'Sim' : 'Não')} disabled style={{ background: '#f5f5f5' }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', gap: 10, marginTop: 10, justifyContent: 'center' }}>
          <button type="submit" className="btn-cadastrar" style={{ minWidth: 100 }} disabled={loading}>Salvar</button>
          <button type="button" style={{ minWidth: 100, background: '#bdbdbd', color: '#fff', fontWeight: 700, borderRadius: 6, border: 'none', padding: '8px 0', cursor: 'pointer' }} onClick={() => navigate('/Configuracoes')}>Cancelar</button>
        </div>
        {message && (
          <p className="mensagem-sucesso" style={{ color: message.startsWith('Erro') ? 'red' : '#388e3c', textAlign: 'center', marginTop: 10 }}>
            {message}
          </p>
        )}
      </form>
      )}
    </div>
  );
}
